import React from 'react';
import '../components/css/scroll-container.css'; 

import certJoinLogo from '../images/certjoin-partner.webp';
import ciscoLogo from '../images/cisco_netacedemy.png';
import compecerLogo from '../images/compecer.png';
import conocerLogo from '../images/conocer.png';

const logos = [
  { id: 1, src: certJoinLogo, alt: 'CertJOIN' },
  { id: 2, src: ciscoLogo, alt: 'Cisco' },
  { id: 3, src: compecerLogo, alt: 'COMPECE' },
  { id: 4, src: conocerLogo, alt: 'CONOCER' },
];

const duplicatedLogos = [...logos, ...logos]; // Duplicar para el loop

function LogoScroller() {
  const animationDuration = '15s'; // Variable JS para la duración
  
  return (
    <div className="scroll-container">
      {/* Pasa la variable a CSS a través de una propiedad style */}
      <div 
        className="scroll-track"
        style={{ '--animation-duration': animationDuration }} 
      >
        {duplicatedLogos.map((logo, index) => (
          <img 
            key={index} 
            src= {logo.src }//{logo.src} 
            alt={logo.alt} 
          />
        ))}
      </div>
    </div>
  );
}

export default LogoScroller;